import React, { ReactElement, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
    useDeleteMessageMutation,
} from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";
import { HtmlRenderer } from "../../html-render/HtmlRenderer";

export default function DeleteMessageAction({ ticketMessageId, text }: {
    text: string,
    ticketMessageId: string
}): ReactElement {
    const [isShowCreate, setIsShowCreate] = useState(false);

    const [body, setBody] = useState(text);

    const [deleteMessage] = useDeleteMessageMutation();

    useEffect(() => {
        setBody(text);
    }, [isShowCreate]);

    const onSave = async () => {
        await deleteMessage({
            variables: {
                ticketMessageId,
            },
        });
        setIsShowCreate(false);
    };

    return (
        <>

            <Confirm
                shouldShow={isShowCreate}
                onConfirm={onSave}
                size="lg"
                confirmText="Delete"
                confirmVariant="danger"
                onHide={() => setIsShowCreate(false)}
                dialogClassName="mt-5"
            >

                <div>
                    <div>
                        Are you sure you want to delete the message:
                    </div>
                    <div className="alert alert-danger mt-2">
                        <HtmlRenderer html={body} />
                    </div>

                </div>

            </Confirm>
            <Dropdown.Item onClick={() => setIsShowCreate(true)} className="text-white">
                Delete Message
            </Dropdown.Item>
        </>
    );
}
